let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hpdFn")).then(() => parcelRequire('7suyn'));